import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import PropertyCard from "@/components/locanest/PropertyCard";

export default function Favorites() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/favorites").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    await api.delete(`/favorites/${id}`);
    setItems((it) => it.filter((p) => p.id !== id));
  };

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-10">
      <div className="text-xs uppercase tracking-[0.25em] text-[#C85A32]">Your saved homes</div>
      <h1 className="font-display text-4xl md:text-5xl mt-2">Favorites</h1>

      <div className="mt-8">
        {loading ? (
          <div className="text-[#5C6B7A]">Loading…</div>
        ) : items.length === 0 ? (
          <div className="bg-[#F0EBE1] rounded-lg p-12 text-center">
            <Heart className="mx-auto text-[#C85A32]" size={36} />
            <div className="mt-3 text-[#5C6B7A]">No favorites yet. Tap the heart icon on any property to save it.</div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="favorites-grid">
            {items.map((p) => <PropertyCard key={p.id} p={p} isFav={true} onFavToggle={() => remove(p.id)} />)}
          </div>
        )}
      </div>
    </div>
  );
}
